const solid = ({ status }) => ({
    _light: {
        borderWidth: 1,
        bg: status && `${status}.25`,
        borderColor: status && `${status}.200`,
        borderRadius: "lg",
    },
});
const variants = {
    solid,
};
export default {
    defaultProps: {
        colorScheme: "default",
        variant: "solid",
    },
    variants,
};
